import { __assign } from "tslib";
import { OnDestroy } from '@angular/core';
import * as i0 from "@angular/core";
var MicrofrontendErrorReportingService = /** @class */ (function () {
    function MicrofrontendErrorReportingService() {
        var _this = this;
        this.handleMicrofrontendErrorReporting = function (event) {
            // SA-8637: defensive guard — see sentry.utils.ts. Sentry comes from the CDN
            // script in index.html; if that didn't load, drop the event silently rather
            // than crashing on `new Sentry.Scope()`.
            if (typeof Sentry === 'undefined') {
                return;
            }
            var payload = event.detail;
            switch (payload.event) {
                case 'captureException':
                    if (Sentry.isInitialized()) {
                        Sentry.captureException(payload.error, _this.buildScope(payload.context));
                    }
                    else {
                        console.error(payload.error, _this.buildScope(payload.context));
                    }
                    break;
                case 'captureMessage':
                    if (Sentry.isInitialized()) {
                        Sentry.captureMessage(payload.message, _this.buildScope(payload.context));
                    }
                    else {
                        console.log(payload.message, _this.buildScope(payload.context));
                    }
                    break;
                case 'captureLog':
                    // Sentry Logs (v10) takes a flat attributes object — tags and extras
                    // collapse into the same record. Requires `enableLogs: true` on init.
                    if (Sentry.isInitialized()) {
                        Sentry.logger[payload.level](payload.message, _this.flattenLogAttributes(payload.context));
                    }
                    else {
                        console[payload.level === 'info' ? 'log' : payload.level](payload.message, _this.flattenLogAttributes(payload.context));
                    }
                    break;
            }
        };
        this.setupEventListener();
    }
    MicrofrontendErrorReportingService.prototype.setupEventListener = function () {
        window.addEventListener('microfrontendErrorReporting', this.handleMicrofrontendErrorReporting);
    };
    MicrofrontendErrorReportingService.prototype.buildScope = function (context) {
        var scope = new Sentry.Scope();
        if (context === null || context === void 0 ? void 0 : context.tags) {
            Object.entries(context.tags).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                scope.setTag(key, value);
            });
        }
        if (context === null || context === void 0 ? void 0 : context.extra) {
            Object.entries(context.extra).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                scope.setExtra(key, value);
            });
        }
        return scope;
    };
    MicrofrontendErrorReportingService.prototype.flattenLogAttributes = function (context) {
        var _a, _b;
        return __assign(__assign({}, ((_a = context === null || context === void 0 ? void 0 : context.tags) !== null && _a !== void 0 ? _a : {})), ((_b = context === null || context === void 0 ? void 0 : context.extra) !== null && _b !== void 0 ? _b : {}));
    };
    MicrofrontendErrorReportingService.prototype.ngOnDestroy = function () {
        window.removeEventListener('microfrontendErrorReporting', this.handleMicrofrontendErrorReporting);
    };
    MicrofrontendErrorReportingService.ngInjectableDef = i0.defineInjectable({ factory: function MicrofrontendErrorReportingService_Factory() { return new MicrofrontendErrorReportingService(); }, token: MicrofrontendErrorReportingService, providedIn: "root" });
    return MicrofrontendErrorReportingService;
}());
export { MicrofrontendErrorReportingService };
